import WolverineConfigDao from '../dao/wolverine-config.dao';
import type { Environment } from '../interfaces/environment';
import type { WolverineConfigDto } from '../interfaces/wolverine-config-dto';

export abstract class WolverineConfigService {
  static getWolverineConfig(env: Environment): Promise<WolverineConfigDto> {
    return WolverineConfigDao.getWolverineConfig(env);
  }
}
